import { render } from "./overAllDialogView.vue?vue&type=template&id=4d98b274&scoped=true&ts=true"
import script from "./overAllDialogView.vue?vue&type=script&lang=ts"
export * from "./overAllDialogView.vue?vue&type=script&lang=ts"

import "./overAllDialogView.vue?vue&type=style&index=0&id=4d98b274&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d98b274"]])

export default __exports__